import React, { useMemo, useRef } from "react";
import { ChevronDownDDS } from "../../../../asset";

const MSSDisplayDayOff = ({
  listDayOff,
  className,
  togglerClassName,
  placeholder,
  disabled,
  ...attrs
}) => {
  const dropdownRef = useRef(null);

  const DayOff = useMemo(() => {
    if (!listDayOff || listDayOff === "" || listDayOff === null) {
      return undefined;
    }
    return listDayOff.split(",");
  }, [listDayOff]);

  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <div
        className={
          disabled ? "container-mss-disabled" : "container-mss-enabled"
        }
      >
        {!DayOff || DayOff.length === 0 ? (
          <span className="text-base text-gray-200 opacity-70">
            No Day Off Selected
          </span>
        ) : (
          <div className="max-w-[420px] flex flex-wrap gap-2 my-2">
            {DayOff.map((item, index) => (
              <span
                className={
                  disabled ? "value-mss-disabled" : "value-mss-enabled"
                }
                key={index}
              >
                {item}
              </span>
            ))}
          </div>
        )}
        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </div>
    </div>
  );
};

export default MSSDisplayDayOff;
